/** Overlapping calls share one run of fn; a call after it settles starts a new run. */
function shareInFlight(fn) {
  let pending = null;
  return (...args) => {
    if (!pending) {
      pending = (async () => fn(...args))().finally(() => {
        pending = null;
      });
    }
    return pending;
  };
}

module.exports = { shareInFlight };
